/**
 * Keeps the active product-gallery thumbnail in view within its strip.
 *
 * When the active image changes (thumbnail click, main-image arrows or swipe),
 * the thumbnail strip scrolls so the newly active thumbnail is fully visible,
 * with a peek of the next/previous thumbnail so it's clear more exist.
 * Works on the product page and inside quick view content (same markup).
 */
(() => {
  if (window.__thumbnailFollow) return;
  window.__thumbnailFollow = true;

  const keepActiveThumbVisible = (item) => {
    const scroller = item.closest('.slider');
    if (!scroller || scroller.scrollWidth <= scroller.clientWidth + 1) return;
    const r = item.getBoundingClientRect();
    const sr = scroller.getBoundingClientRect();
    const peek = Math.min(r.width * 0.7, 50);
    if (r.right > sr.right - peek) {
      scroller.scrollBy({ left: r.right - sr.right + peek, behavior: 'smooth' });
    } else if (r.left < sr.left + peek) {
      scroller.scrollBy({ left: r.left - sr.left - peek, behavior: 'smooth' });
    }
  };

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      const t = m.target;
      if (
        t.nodeType === 1
        && t.classList.contains('is-active')
        && t.matches('.thumbnails .slider__item')
        && (!m.oldValue || !m.oldValue.includes('is-active'))
      ) {
        keepActiveThumbVisible(t);
      }
    }
  });

  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
    attributeOldValue: true
  });
})();
